import { Reveal, Eyebrow } from "@/lib/motion";

const PERSONAS = [
  {
    role: "Ops Manager",
    owns: "You own throughput and SLA compliance.",
    body: "RelayOps shows you exactly where handoffs stall and routes around the bottleneck automatically.",
  },
  {
    role: "COO",
    owns: "You own the cost of every workflow.",
    body: "RelayOps cuts the manual coordination tax out of your operation and turns “we think we’re efficient” into a number you can report.",
  },
  {
    role: "Team Leads",
    owns: "You own getting the work done.",
    body: "RelayOps tells your team exactly what’s theirs and cuts the errors that come from unclear ownership.",
  },
];

export default function BuiltFor() {
  return (
    <section id="teams" className="relative bg-bg-primary/55 py-24 backdrop-blur-sm lg:py-32">
      <div className="container-max band-pad">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow testId="teams-eyebrow">Built for your team</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Whoever owns the number, owns the view.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {PERSONAS.map((p, i) => (
            <Reveal key={p.role} delay={i * 0.08}>
              <div
                data-testid={`persona-${i}`}
                className="flex h-full flex-col rounded-2xl border border-hairline bg-bg-surface p-8 transition-colors duration-300 hover:border-signal/30"
              >
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal">
                  {p.role}
                </span>
                <p className="mt-5 font-display text-lg font-medium leading-snug text-ink">
                  {p.owns}
                </p>
                <p className="mt-4 leading-relaxed text-ink-muted">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
